import { render, staticRenderFns } from "./selectedGoods.vue?vue&type=template&id=4a58d982&scoped=true&"
import script from "./selectedGoods.vue?vue&type=script&lang=js&"
export * from "./selectedGoods.vue?vue&type=script&lang=js&"
import style0 from "./selectedGoods.vue?vue&type=style&index=0&id=4a58d982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58d982",
  null
  
)

export default component.exports